module.exports = __webpack_public_path__ + "static/img/DavidWarner.63d421c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DavidWarner.jpg
// module id = wdSh
// module chunks = 0